/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import Header from "../components/Header";

const HeaderContainer = (props) => {
  const {
    handleLogout,
  } = props;

  return <Header handleLogout={handleLogout} />;
};

HeaderContainer.defaultProps = {
};

HeaderContainer.propTypes = {
  handleLogout: PropTypes.func.isRequired,
};

export default HeaderContainer;
